import { defineMessages } from 'react-intl';

const messages = defineMessages({
  labelFullCalendar: {
    id: 'FullCalendar',
    defaultMessage: 'Calendar',
  },
  labelCalendarSettings: {
    id: 'Calendar Settings',
    defaultMessage: 'Calendar Settings',
  },
  labelCalendarURL: {
    id: 'Calendar URL',
    defaultMessage: 'Calendar URL',
  },
  descriptionCalendarURL: {
    id: 'Must point to an iCal/ics file.',
    defaultMessage: 'Must point to an iCal/ics file.',
  },
  labelDayGridMonth: {
    id: 'Month',
    defaultMessage: 'Month',
  },
  labelTimeGridWeek: {
    id: 'Week',
    defaultMessage: 'Week',
  },
  labelTimeGridDay: {
    id: 'Day',
    defaultMessage: 'Day',
  },
  labelListDay: {
    id: 'List day',
    defaultMessage: 'List day',
  },
  labelListWeek: {
    id: 'List week',
    defaultMessage: 'List week',
  },
  labelListMonth: {
    id: 'List month',
    defaultMessage: 'List month',
  },
  labelNext: {
    id: 'Next',
    defaultMessage: 'Next',
  },
  lebelPrev: {
    id: 'Previous',
    defaultMessage: 'Previous',
  },
  labelToday: {
    id: 'Today',
    defaultMessage: 'Today',
  },
  labelToolbarLeft: {
    id: 'Toolbar left',
    defaultMessage: 'Toolbar left',
  },
  labelToolbarCenter: {
    id: 'Toolbar center',
    defaultMessage: 'Toolbar center',
  },
  labelToolbarRight: {
    id: 'Toolbar right',
    defaultMessage: 'Toolbar right',
  },
  labelInitialView: {
    id: 'Initial view',
    defaultMessage: 'Initial view',
  },
  labelTitle: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  labelTitleFormatYear: {
    id: 'Title: Year format',
    defaultMessage: 'Title: Year format',
  },
  labelTitleFormatMonth: {
    id: 'Title: Month format',
    defaultMessage: 'Title: Month format',
  },
  labelTitleFormatDay: {
    id: 'Title: Day format',
    defaultMessage: 'Title: Day format',
  },
  labelTitleShort: {
    id: 'Short',
    defaultMessage: 'Short',
  },
  labelTitleLong: {
    id: 'Long',
    defaultMessage: 'Long',
  },
  labelTitleNumeric: {
    id: 'Numeric',
    defaultMessage: 'Numeric',
  },
  labelTitle2Digit: {
    id: '2-digit',
    defaultMessage: '2-digit',
  },
  labelInitialDate: {
    id: 'Initial date',
    defaultMessage: 'Initial date',
  },
  descriptionInitialDate: {
    id: 'If not set, current date is used.',
    defaultMessage: 'If not set, current date is used.',
  },
});

export default messages;
